<span class="break-words">{{ translation }}</span>
